import React, { useState, useContext } from "react";
import { CustomModal } from "../../../components/CustomModal";
import AboutModal from "./modals/aboutModal/aboutModal";
import { useMutation } from "@tanstack/react-query";
import { updateExpert } from "../../../service/api";
import { useQueryClient } from "@tanstack/react-query";
import ExpertDataContext from "../../../context/expertDataContext";

function About({ note }) {
  const queryClient = useQueryClient()
  const { expertData, resetExpertDataContext } = useContext(ExpertDataContext);
  const [openModal, setOpenModal] = useState(false);
  const [openMiniModal, setOpenMiniModal] = useState(false);
  const [loading,setLoading] = useState()

  let w = document.documentElement.clientWidth || window.innerWidth;

  const modalHandler = () => {
    resetExpertDataContext()
    if (w > 640) {
      setOpenModal(true);
    } else if (w <= 640) {
      setOpenMiniModal(true);
    }
  };

  const mutation = useMutation(updateExpert, {
    onSuccess: () => {
      queryClient.invalidateQueries(["expertData"]);
      setOpenModal(false);
      setOpenMiniModal(false);
      setLoading(false)
    },
    onMutate:()=>{
setLoading(true)
    }
  });

  const onOk = () => {
    mutation.mutate(expertData);
  };

  
  return (
    <div
   
      className=" w-full relative hover:cursor-pointer hover:brightness-90 hover:shadow-lg "
      
    >
 
      <div
        onClick={modalHandler}
       
        className="flex flex-col font-body bg-white p-6 rounded-xl gap-5"
      >
        <h2 className="text-[#005AC7] text-2xl font-bold text-right max-lg:text-[0.875rem]">
          سخن کارشناس
        </h2>
        <p className="text-[#404848]  font-medium text-justify">{note}</p>
      </div>
      {openModal && (
        <CustomModal
          onOk={onOk}
          size={"55vw"}
          loading={loading}
          visible={openModal}
          handleCancel={() => setOpenModal(false)}
        >
          <AboutModal text={note} />
        </CustomModal>
      )}
      {openMiniModal && (
        <CustomModal
        loading={loading}
          onOk={onOk}
          size={"100vw"}
          visible={openMiniModal}
          handleCancel={() => setOpenMiniModal(false)}
        >
          <AboutModal text={note} />
        </CustomModal>
      )}
    </div>
  );
}

export default About;
